import { Pipe, PipeTransform } from '@angular/core';
import { addSpacesToEnum } from '../enum-helper';

@Pipe({
    name: 'enumToString',
    standalone: false
})
export class EnumToStringPipe implements PipeTransform {
  transform(value: number, enumType: object): string {
    return addSpacesToEnum(enumType, value);
  }
}
